import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-28">
      <div className="flex flex-col items-center text-center max-w-lg mx-auto">
        <span className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 text-4xl mb-6">
          <i className="ri-compass-3-line"></i>
        </span>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500">
          你访问的页面不存在或已被移动
          <span className="block mt-1 text-xs text-foreground-400 break-all">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-home-4-line"></i>返回首页
          </Link>
          <Link to="/categories" className="inline-flex items-center gap-2 px-5 py-2.5 text-sm rounded-md border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-apps-2-line"></i>浏览全部分类
          </Link>
        </div>
      </div>
    </div>
  );
}